import React from 'react';
import  { useState } from 'react';
import  { useEffect }from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Unstable_Grid2';
import { APIvar } from '../services/variables';
import Link from '@mui/material/Link';
import axios from 'axios'
import './Navigation.css'
import { APICall, test } from './services/api.service'
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'
import store from './redux/store'
import * as actions from './redux/actions.js'
import * as useLocalStorage from './services/useLocalStorage'
import Logo from "../images/logo_atlas.png";
import {ReactComponent as CloseIcon} from '../images/icons/close-circle.svg'
import { IoPerson } from "react-icons/io5";
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Loader3 from './Loader3';

import {ReactComponent as UserIcon} from '../images/icons/person-circle.svg';


import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const useColor = APIvar.colorUse;

function Navigation() {
  const [anchorEl1, setAnchorEl1] = React.useState(null);
    const open = Boolean(anchorEl1);

    const [anchorEl2, setAnchorEl2] = React.useState(null);
    const open2 = Boolean(anchorEl2);

    const [anchorEl3, setAnchorEl3] = React.useState(null);
    const open3 = Boolean(anchorEl3);

    const [anchorEl4, setAnchorEl4] = React.useState(null);
    const open4 = Boolean(anchorEl4);
    
    const [anchorEl5, setAnchorEl5] = React.useState(null);
    const open5 = Boolean(anchorEl5);
    
    const [anchorsArray, setAnchorsArray] = React.useState(new Array(6).fill(null));
    const [showSettings, setShowSettings] = useState(false);
    const [listOfPozivni, setListOfPozivni] = useState([]);
    
    
    const [poziv, setPoziv] = useState(JSON.parse(useLocalStorage.getItem("tkc")));
    //const poziv = useSelector((state) => state.TKC ? state.TKC.pozivni: '');
    
    
    const [isLoading, setLoading] = useState(false);

    //const [token, setToken] = useState("")
    const token = useSelector((state) =>useLocalStorage.getItem("token"))

    const togglingValue = useSelector((state) => state.togglingVariable?state.togglingVariable.value: 0);


    const dispatch = useDispatch()

    const navigate = useNavigate()

    const ref = localStorage.getItem("id");

    const adminDaily = localStorage.getItem("adminDaily");

    const adminNumeration = localStorage.getItem("adminNumeration");

    const adminAll = localStorage.getItem("adminAll");
    const adminDailyData = localStorage.getItem("adminDailyData");
    const stat = localStorage.getItem("stat");
    const allStat = localStorage.getItem("allStat");
    const edit0600 = localStorage.getItem("edit0600");
    const edit0800 = localStorage.getItem("edit0800");
    

    const [see060, setSee060] = useState(false);

    const [see0800, setSee0800] = useState(false);

    const [seeAll, setSeeAll] = useState(false);

    const [seeStat, setSeeStat] = useState(false);

    const [seeAllStat, setSeeAllStat] = useState(false);

    const [seeDataAdmin, setSeeDataAdmin] = useState(false);

    const [seeAdminVal, setSeeAdminVal] = useState(false);

    const [seeAdminNumeracija, setSeeAdminNumeracija] = useState(false);
    
    const isMenuOpen = useSelector(store=>store.menu?store.menu.open:false)


    const toastError = {                                                        
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
    };

    const toastSuccess = {                                                        
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "light",
    };

    const toastInfo = {                                                        
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "light",
    };




    const handleClick = (event, index) => {
        setAnchorEl1(event.currentTarget);
        var copyAnchorsArray =[ ...anchorsArray]
        copyAnchorsArray[index] = event.currentTarget
        setAnchorsArray(copyAnchorsArray)
    };
    const handleClose = () => {
        var copyAnchorsArray =[ ...anchorsArray]
        copyAnchorsArray.fill(null)
        setAnchorsArray(copyAnchorsArray)

    };



    const handleIconClick = () => {


      console.log("logout!!!  ")

    };

    useEffect(()=> {

      if(token && token!=""){
            GetPozivni()
      }

      console.log("Ref: ")
      console.log(ref);

      console.log(adminDailyData);
      console.log(adminDailyData==1)
      console.log(adminDailyData=='1');


      

      if(adminDailyData== 1) setSeeDataAdmin(true);
      if(adminDaily ==1) {
        console.log("Setting to see admin val!!!");
        setSeeAdminVal(true);
      }
      if(stat == 1) setSeeStat(true);

      if(allStat == 1) setSeeAllStat(true); 

      if(edit0600 == 1) setSee060(true);

      if(edit0800 == 1) setSee0800(true);

      if(adminNumeration == 1) setSeeAdminNumeracija(true);



      console.log("UseEffect Navigation");

 
    },[])


    const GetPozivni = async() => {
      dispatch(actions.isLoading());
     await  APICall("/GetPozivni", {
        platform: '0',
        version:'1.0'
      },{
        token
      }).then(response =>{
              if(response.status !== 200) {

                if(response.status == 401){

                        console.log("Istekla sesija");

                        toast.error(response.data.message, toastError);
                        
                        dispatch(actions.logOut());
                        navigate('/');

                } else{

                        //toast.error(response.data.message, toastError);


                }
                



            } else {
                
                    console.log("Getting pozivni in navigation!!!!!!!")
                    console.log(response.data.list);
                    let tmp = response.data.list;
                    tmp = tmp.sort((a,b) => a.pozivni - b.pozivni);
                    console.log("Sorted!!!");
                    console.log(tmp);
                    setListOfPozivni(tmp);
            }


            if (response==undefined) dispatch(actions.isNotLoading());
      })
      dispatch(actions.isNotLoading());
    }


  if(token) {
      return (
        <>
        <div className={`navigation-container ${isMenuOpen ? "is-extended": ""}`}
          onMouseEnter={()=> dispatch(actions.openMenu())}
          onMouseLeave={()=> dispatch(actions.closeMenu())}>



                <div className="navigation-logo-container">
                          <img src={Logo} alt="Logo" className="navigation-logo"/>
                        
                </div>
                <div className="navigation-menu" sytle={{width:'85%'}}>
    
                  <Button sx={{marginRight:"20px"}} className="navigation-button" id="basic-button-0"
                    onClick={(event)=> {
                        handleClick(event,0);
    
                    }}
    
                    aria-controls={Boolean(anchorsArray[0]) ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={Boolean(anchorsArray[0]) ? 'true' : undefined}
                    //onClick={(event)=> {
                    //    handleClick(event,0);
                    //}}
                  >
                    Održavanje podataka
                  </Button>    
    
                  <Menu id="basic-menu-0"
                    anchorEl={anchorsArray[0]}
                    open={Boolean(anchorsArray[0])}
                    onClose={()=>handleClose()}
                    MenuListProps={{
                      'aria-labelledby': 'basic-button',
                    }}
                  
                  >
                    <MenuItem onClick={()=>handleClose()} >   
                      <Link href={`BijeleStranice`} underline="hover" color="inherit">
                        Bijele stranice
                      </Link>
                    </MenuItem>                    
                    <MenuItem onClick={()=>handleClose()} >   
                      <Link href={`ZuteStranice`} underline="hover" color="inherit">
                        Žute stranice
                      </Link>
                    </MenuItem>     
                    <Divider />               


                    <MenuItem onClick={()=>handleClose()} >   
                      <Link href={`Telefoni`} underline="hover" color="inherit">
                        Telefoni
                      </Link>
                    </MenuItem>

 
                    <Divider />
                    <MenuItem onClick={()=>handleClose()} disabled>
                      <Link href={`DnevnepromjeneDonat`} underline="hover" color="inherit">
                        Dnevne promjene Donat
                      </Link>                
                    </MenuItem>
                    <MenuItem onClick={()=>handleClose()} disabled>
                      <Link href={`DnevnepromjeneTMobile`} underline="hover" color="inherit">
                        Dnevne promjene T-Mobile
                      </Link>                
                    </MenuItem>
                    <MenuItem onClick={()=>handleClose()}>
                      <Link href={`DnevnepromjeneFiksni`} underline="hover" color="inherit">
                        Dnevne promjene ostali
                      </Link>                
                    </MenuItem>  
                    <MenuItem onClick={()=>handleClose()} disabled>
                      <Link href={`DnevnepromjeneTele2`} underline="hover" color="inherit">
                        Dnevne promjene Telemach
                      </Link>                
                    </MenuItem>      
                    <MenuItem onClick={()=>handleClose()}>
                      <Link href={`DnevnepromjeneA1`} underline="hover" color="inherit">
                        Dnevne promjene A1
                      </Link>                
                    </MenuItem>   
                    <Divider />    
                    <MenuItem onClick={()=>handleClose()}>
                      <Link href={`BadData`} underline="hover" color="inherit">
                        Neispravni dolazni podaci
                      </Link>                
                    </MenuItem>   
                    <Divider />                                                                                 
                    <MenuItem disabled>
                      <Link href={'sifrator'} underline="hover" color="inherit" >
                          Šifrator
                      </Link>
                    </MenuItem>
                    
    
                  <MenuItem >
                      <Link href={'NadzoriUpravljanjeDnevnimSpiskovima'} underline="hover" color="inherit">
                          Nadzor i upravljanje dnevnim spiskovima
                      </Link>
                    </MenuItem>

                        <MenuItem >
                      <Link href={'NadzorTKoperatora'} underline="hover" color="inherit">
                          Nadzor TK operatora
                      </Link>
                    </MenuItem>              
                  
                  {/*
                  {!seeAll &&<MenuItem onClick={()=>handleClose()} >
                      <Link href={`Statistika`} underline="hover" color="inherit">
                      Statistika
                      </Link>
    
                  </MenuItem>}  */}
                  {seeStat && <MenuItem onClick={()=>handleClose()} >
                      <Link href={`Statistika`} underline="hover" color="inherit">
                      Statistika
                      </Link>
    
                  </MenuItem>}

                  {seeAdminVal && <MenuItem onClick={()=>handleClose()} >
                      <Link href={`AdminDaily`} underline="hover" color="inherit">
                      Administracija korisnika (dolazni podaci)
                      </Link>
    
                  </MenuItem>}        
                  {seeAdminNumeracija && <MenuItem onClick={()=>handleClose()} >
                      <Link href={`AdminNumeration`} underline="hover" color="inherit">
                      Administracija korisnika (numeracija)
                      </Link>
    
                  </MenuItem>}                              
                  </Menu>            
    
                  <Button  sx={{marginRight:"20px"}} className="navigation-button" id="basic-button-1"
                    onClick={(event)=> {
                        handleClick(event,1);
    
                    }}
    
                    aria-controls={Boolean(anchorsArray[1]) ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={Boolean(anchorsArray[1]) ? 'true' : undefined}

                  >
                    Upiti i liste
                  </Button>    
    
                  <Menu id="basic-menu-1"
                    anchorEl={anchorsArray[1]}
                    open={Boolean(anchorsArray[1])}
                    onClose={()=>handleClose()}
                    MenuListProps={{
                      'aria-labelledby': 'basic-button',
    
                    }}
                  >
                    {!seeAll &&<MenuItem onClick={()=>handleClose()} 
                    disabled
                    >
                      <Link href={`TelefonskiImenik`} underline="hover" color="inherit" >
                      Liste
                      </Link>
    
                    </MenuItem>}
                    {seeAll &&<MenuItem onClick={()=>handleClose()} 
                    disabled
                     >
                      <Link href={`TelefonskiImenik`} underline="hover" color="inherit" >
                      Liste
                      </Link>
    
                    </MenuItem>}

                    {seeAll &&<MenuItem onClick={()=>handleClose()} >
                      <Link href={`Analiza`} underline="hover" color="inherit">
                      Analiza
                      </Link>
    
                    </MenuItem>}
                    {!seeAll &&<MenuItem onClick={()=>handleClose()} >
                      <Link href={`Analiza`} underline="hover" color="inherit">
                      Analiza
                      </Link>
    
                    </MenuItem>}                    

                  </Menu>
       

    
                  {see060 && <Button sx={{marginRight:"20px"}}  className="navigation-button" id="basic-button-3"
                    onClick={(event)=> {
                        handleClick(event,3);
    
                    }}
    
                    aria-controls={Boolean(anchorsArray[3]) ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={Boolean(anchorsArray[3]) ? 'true' : undefined}

                  >
                    Ostalo
                  </Button>   } 
    

                  {see060 && <Menu id="basic-menu-3"
                    anchorEl={anchorsArray[3]}
                    open={Boolean(anchorsArray[3])}
                    onClose={()=>handleClose()}
                    MenuListProps={{
                      'aria-labelledby': 'basic-button',
                    }}
                  >

                    {see060 && <MenuItem onClick={()=>handleClose()}  >
                      <Link href={`TelefoniPRS`} underline="hover" color="inherit">
                        Telefoni  - 060, 061... (PRS)
                      </Link>
                    </MenuItem>}

                    {see060 && <MenuItem onClick={()=>handleClose()} >
                      <Link href={`PrimarnaPRS`} underline="hover" color="inherit">
                        Primarna dodjela 060, 061...
                      </Link>
                    </MenuItem>}
                    <Divider />
                    {see0800 && <MenuItem onClick={()=>handleClose()} >
                      <Link href={`Telefoni_0800_072`} underline="hover" color="inherit">
                        Telefoni - 0800 + 072
                      </Link>                
                    </MenuItem>}
            
                    {see0800 && <MenuItem onClick={()=>handleClose()} >
                      <Link href={`Primarna0800`} underline="hover" color="inherit">
                        Primarna dodjela 0800 + 072
                      </Link>                
                    </MenuItem>} 
                  </Menu>}
    

                </div>

                
                <div className="navigation-select-user">
                  
                  {/*<FormControl fullWidth>
                    <InputLabel>Mrežna grupa</InputLabel>
                    <Select
                    
                      value={poziv?poziv.tkc:''}
                      label="Mreža"
                      id="network-select" // Set the ID here

                      
                    
                     
                      onChange={(event) => {
                        
                        

                        console.log("Odabrana mreža u navigation!!!");
                        console.log(event.target.value);

                        if(event.target.value == ''){

                          console.log("Odabrano bezmrežje!!!");

                          let networkCallingCode = {tkc:'',pozivni:''};

                          setPoziv(networkCallingCode);

                          dispatch(actions.setActiveTKC(networkCallingCode));

                          dispatch(actions.toggleSomeValue(togglingValue == 0? 1:0));


                        } else {


                          let chosenTKC = event.target.value;
                        

                          let networkCallingCode = listOfPozivni.find((it) => it.tkc === chosenTKC);
  
                          console.log(networkCallingCode);
                          console.log(networkCallingCode.pozivni);
                          console.log(networkCallingCode.tkc);
  
  
                          setPoziv(networkCallingCode);
  
                          console.log("Setting poziv to: ");
                          console.log(networkCallingCode.tkc);
                                                  
                          ///////////////////////////////////////
                          //sessionStorage.setItem("mreza", event.target.value);
                          //sessionStorage.setItem("mreza", networkCallingCode);
                          ////////////////////////////////////////
                          
                          //dispatch(actions.selectKorisnik(event.target.value))

                          //dispatch(actions.selectKorisnik(networkCallingCode))
                          dispatch(actions.setActiveTKC(networkCallingCode));

                          dispatch(actions.toggleSomeValue(togglingValue == 0? 1:0));
  

                        }


                        


                      }}
                    >
                      {listOfPozivni && listOfPozivni.map((poziv,index)=> {
                        return (
                          <MenuItem value={poziv.tkc} name={poziv.pozivni} key={index}>{poziv.pozivni}</MenuItem>

                        )
                      })}
                      <MenuItem value={''} name={''} >Svi</MenuItem>

                    </Select>
                  </FormControl>*/}
                </div>

                <div className='menu-selector' 
                         onClick={() => setShowSettings(!showSettings)}
                                                        
                                                        >
                         <UserIcon style={{fill: '#29648a', }} size="1x"/>
                </div> 
                <div className="navigation-settings-modal" 
                style={{height: showSettings ? "fit-content" : "0px", 
                        opacity: showSettings ? 1 : 0, 
                        visibility: showSettings ? "visible" : "hidden",
                        top: showSettings ? "70px" : "-200px"
                        }}>
                <CloseIcon className="navigation-settings-close" style={{fill: '#29648a', }} size="1x"  onClick={()=> {
                    setShowSettings(false)
                }} />
                <div className="navigation-settings-logout" onClick={()=>{
                            dispatch(actions.logOut())
                            setShowSettings(false)
                            navigate('/')
                    }}>
                    Odjava
                </div>

                {/*<div className="navigation-settings-settings">
                    Postavke
                </div>*/}
                </div>
   
        </div>
        
        {/*<div className='navigation-toggle-menu' onClick={()=> {
             dispatch(actions.openMenu())
            }}>
              <img src={Logo} alt="Logo" className="navigation-logo"/>
            
                
        </div>*/}

        </>
      );
  } else {
    return(
    <div  className="navigation-container">



   
    </div>
)
  }
}

export default Navigation;
